export const SUPABASE_TABLES = {
  // Tables de traduction
  TRANSLATIONS: {
    name: 'trad_txt',
    columns: ['key', 'fr', 'en', 'es', 'it', 'pt', 'de', 'nl', 'ja', 'zh', 'ru']
  },
  CATEGORY_TRANSLATIONS: {
    name: 'trad_cat_type',
    columns: ['key', 'fr', 'en', 'es', 'it', 'pt', 'de', 'nl', 'ja', 'zh', 'ru']
  },
  
  // Tables RGPD et confidentialité
  RGPD: {
    name: 'rgpd_config',
    columns: ['key', 'enabled', 'cookie_name', 'cookie_duration', 'cookie_category']
  },
  PRIVACY_POLICY: {
    name: 'privacy_policy',
    columns: ['key', 'order', 'title_fr', 'content_fr']
  },
  
  // Tables de navigation et sections
  NAVIGATION: {
    name: 'hotels_navigation',
    columns: ['hotel_id', 'type_rubrique', 'section_id', 'icon', 'replace_img']
  },
  SECTIONS: {
    name: 'hotels_section',
    columns: ['hotel_id', 'section_id', 'type_rubrique', 'name', 'description']
  },
  SECTION_TRANSLATIONS: {
    name: 'translations_section',
    columns: ['hotel_id', 'section_id', 'item_id', 'source_hash', 'fr', 'en', 'es', 'it', 'pt', 'de', 'nl', 'ja', 'zh', 'ru']
  }
} as const;

export type TableName = keyof typeof SUPABASE_TABLES;
export type TableConfig = typeof SUPABASE_TABLES[TableName];